export const modals = {
  addCard: "addCard",
  editCard: "editCard",
  upgrade: "upgrade",
  payPending: "payPending",
  delete: "delete",
  deleteSuccess: "deleteSuccess",
  pause: "pause",
  pauseSuccess: "pauseSuccess",
  unpause: "unpause",
  unpauseSuccess: "unpauseSuccess",
  renew: "renew",
  payment: "payment",
  deleteEmail: "deleteEmail",
  deleteEmailNew: "deleteEmailNew",
  deleteEmailSuccess: "deleteEmailSuccess",
  deletePhone: "deletePhone",
  deletePhoneNew: "deletePhoneNew",
  deletePhoneSuccess: "deletePhoneSuccess",
  addPhone: "addPhone",
  addPhoneNew: "addPhoneNew",
  addEmail: "addEmail",
  addEmailNew: "addEmailNew",
  addPhoneSuccess: "addPhoneSuccess",
  addEmailSuccess: "addEmailSuccess",
  paymentSuccess: "paymentSuccess",
  confirm: "confirm",
  name: "name",
  media: "media",
  practiceArea: "practiceArea",
  languages: "languages",
  bio: "bio",
  editLawFirm: "editLawFirm",
  lawFirmLocation: "lawFirmLocation",
  license: "license",
  education: "education",
  association: "association",
  avvoReviews: "avvoReviews",
  yelpReviews: "yelpReviews",
  verification: "verification",
  verificationSuccess: "verificationSuccess",
  insurances: "insurances",
  listingBasics: "listingBasics",
  downgrade: "downgrade",
  downgradePeriod: "downgradePeriod",
  downgradePeriodSuccess: "downgradePeriodSuccess",
  downgradeSuccess: "downgradeSuccess",
  addNewListing: "addNewListing",
  messages: "messages"
};

export const typeReview = {
  avvo: "avvo",
  yelp: "yelp"
};

export const indexEdit = {
  education: null,
  association: null,
  license: null,
  lawFirmLocation: null,
  practiceArea: null,
  language: null,
  insurances: null
};

export const validationNames = {
  website: "Website",
  locations: "Locations",
  workingHours: "Hours of Operation",
  phone: "Phone",
  licenses: "Licenses",
  name: "Name",
  bio: "Bio",
  pictures: "Pictures",
  business: "Business",
  educations: "Educations",
  associations: "Associations",
  yelp: "Yelp",
  language: "Language",
  specialties: "Specialties",
  events: "Events",
  insurance: "Insurance",
  calendar: "Calendar",
  coverImage: "Cover Image",
  parentOrganization: "Parent Organization",
  tags: "Tags",
  communities: "Communities",
  job: "Job",
  socialMedia: "Social Media",
  additionalImages: "Additional Images",
  video: "Video",
  freeConsultation: "Free Consultation",
  experience: "Experience",
  linkedInCompany: "LinkedIn Company",
  linkedInProfile: "LinkedIn Profile",
  directMessages: "Direct Message",
  publications: "Publications"
};

export const verificationTypes = {
  phone: "phone",
  email: "email"
};

export const listingType = {
  regular: "regular",
  ppl: "ppl"
};

export const statuses = {
  active: "Active",
  approved: "Approved",
  synced: "Synced",
  draft: "Draft",
  pending: "Pending Review",
  pendingPayment: "Pending Payment",
  rejected: "Rejected",
  paused: "Paused",
  expired: "Expired",
  neverPublished: "Never Published",
  deleted: "Deleted",
  transferred: "Transferred"
};

/**
 * Raw hlm_listing.publish_status codes.
 * Mirrors Listing::STATUS_PUBLISH_* in amember/members/application/listings/library/Listing.php.
 */
export const publishStatusCodes = {
  neverPublished: 0,
  active: 1,
  paused: 2,
  pendingPayment: 3,
  expired: 4,
  deleted: 5,
  transferred: 6
};

/**
 * i18n keys for publish_status codes. Pending Payment has no key yet; callers fall back to the
 * API's English label (Listing::$publishStatusText) for any code missing here.
 */
export const publishStatusLabelKeys = {
  [publishStatusCodes.neverPublished]: "dashboard_listings_status_neverpublished",
  [publishStatusCodes.active]: "active",
  [publishStatusCodes.paused]: "dashboard_listings_status_paused",
  [publishStatusCodes.expired]: "expired",
  [publishStatusCodes.deleted]: "dashboard_listings_status_deleted",
  [publishStatusCodes.transferred]: "dashboard_listings_status_transferred"
};

/** Raw edit_status values from the listing API (editor child lifecycle). */
export const editStatuses = {
  draft: "draft",
  pending: "pending",
  rejected: "rejected",
  synced: "synced"
};

export const isListingDraft = value => value === true || value === 1 || value === "1";

/** Publish Draft is only available when the editor child is in draft state. */
export const canPublishEditorDraft = ({ isDraft, editStatus } = {}) => {
  if (editStatus === editStatuses.pending || editStatus === editStatuses.synced) {
    return false;
  }
  if (editStatus === editStatuses.draft) {
    return true;
  }
  return isListingDraft(isDraft);
};

/** Delete/reset draft is only for editor children with unsynced draft changes. */
export const showEditorDeleteDraft = ({ isDraft, parentId, editStatus } = {}) => {
  if (parentId == null || Number(parentId) <= 0) {
    return false;
  }
  if (editStatus === editStatuses.draft) {
    return true;
  }
  return isListingDraft(isDraft);
};

export const redStatuses = ["Paused", "Pending Payment", "Expired", "Changes Rejected"];

export const emptyFilters = {
  freesponsor: ["free", "sponsor"],
  professiongroups: [
    { profession_group_id: "2", title: "Individual Professional's Listing" },
    { profession_group_id: "3", title: "Organization's Listing" },
    { profession_group_id: "4", title: "Place Of Worship Listing" }
  ]
};

// The fixed choices of the list Filters. The Directory choices are not here: the server sends the member's own
// (`filters.directories`, GROWTH-7594).
export const listFilterOptions = {
  professiongroups: [
    { profession_group_id: 3, title: "Individual professionals listing" },
    { profession_group_id: 1, title: "Organization\u2019s listing" },
    { profession_group_id: 2, title: "Place of worship listing" }
  ],
  freesponsor: [
    { title: "dashboard_listings_free", id: "free" },
    { title: "dashboard_listings_sponsor", id: "sponsor" }
  ],
  change_status: [
    { title: "dashboard_listings_approved", id: "Approved" },
    { title: "dashboard_listings_pedingreview", id: "Pending Review" },
    { title: "dashboard_listings_rejected", id: "Rejected" }
  ],
  publish_status: [
    { title: "dashboard_listings_neverpublished", id: "Never Published" },
    { title: "dashboard_listings_active", id: "Active" },
    { title: "dashboard_listings_paused", id: "Paused" },
    { title: "dashboard_listings_expired", id: "Expired" }
  ]
};

export const filterTypes = {
  directory: "directory",
  status: "status",
  changes: "changes",
  option: "option"
};

export const imageDelivery = "https://imagedelivery.net";

export const listingProfessionType = {
  events: "/my-events",
  jobs: "/my-jobs",
  organizations: "/my-organizations"
};

export const listingSectionPaths = ["details", "licenses", "bio", "donations", "location", "publications", "messages", "notifications"];

/** Scalar hlm_listing columns saved via save_website / save_intro_video / save_consultation. */
export const listingScalarAutosaveFields = ["website", "intro_video", "consultation"];

/** Fallback Heritageweb.com publication when text_lang directories are empty (bio editor). */
export const DEFAULT_HERITAGEWEB_DIR_ID = 1207;
export const DEFAULT_ENGLISH_LANG_ID = 26;
export const DEFAULT_HERITAGEWEB_DIRECTORY_NAME = "Heritageweb.com";

export const isListingDetailPath = pathname => /^\/(profile|my-jobs|my-events|my-organizations|listings)(\/|$)/.test(pathname);

/** Routes that load/save via api-v2 listing resources (profiles, events, jobs, organizations). */
export const isApiV2EditorPath = pathname =>
  ["/my-events", "/my-jobs", "/my-organizations", "/profile"].some(segment => String(pathname || "").includes(segment));

export const isProfileEditorPath = pathname => {
  const normalized = String(pathname || "");
  return normalized === "/profile" || normalized.startsWith("/profile/");
};

export const resolveListingTabPath = pathname => {
  const lastPart =
    pathname
      .split("/")
      .filter(Boolean)
      .pop() || "";
  return listingSectionPaths.includes(lastPart) ? lastPart : "details";
};

const LISTING_DETAIL_ENTITY_SEGMENTS = ["my-organizations", "my-events", "my-jobs", "listings"];

/**
 * Stable identity for a listing editor URL, ignoring tab segments.
 * Profile editor is a single identity; other editors are `marker:id`.
 *
 * @param {string} pathname
 * @returns {string|null}
 */
export const resolveListingEditorIdentity = pathname => {
  const normalized = String(pathname || "");

  if (!isListingDetailPath(normalized)) {
    return null;
  }

  if (isProfileEditorPath(normalized)) {
    return "profile";
  }

  const segments = normalized.split("/").filter(Boolean);
  const markerIndex = segments.findIndex(segment => LISTING_DETAIL_ENTITY_SEGMENTS.includes(segment));

  if (markerIndex === -1) {
    return null;
  }

  const idSegment = segments[markerIndex + 1];

  if (!idSegment || listingSectionPaths.includes(idSegment)) {
    return null;
  }

  return `${segments[markerIndex]}:${idSegment}`;
};

/**
 * True when both paths are the same listing editor (tab changes included).
 *
 * @param {string} currentPathname
 * @param {string} nextPathname
 * @returns {boolean}
 */
export const isSameListingEditorNavigation = (currentPathname, nextPathname) => {
  const currentIdentity = resolveListingEditorIdentity(currentPathname);
  const nextIdentity = resolveListingEditorIdentity(nextPathname);
  return Boolean(currentIdentity && nextIdentity && currentIdentity === nextIdentity);
};

/** Autosave lifecycle in `listing.unsavedSections[listingScope][section]`. */
export const listingUnsavedSectionStatus = {
  pending: "pending",
  failed: "failed"
};

/**
 * One shared result for "no unsaved sections". `useListingUnsavedStatus` selects
 * it with `useSelector`, which compares by reference, so a new `{}` would
 * re-render the listing editor's unsaved-changes controller on every dispatch
 * (GROWTH-7494). Frozen because every empty lookup shares it.
 */
const EMPTY_UNSAVED_SECTIONS = Object.freeze({});

/**
 * Section statuses for one listing editor. `unsavedSections` is nested by
 * autosave listing prefix (`apiPrefix:ownerId:listingId:`) so a delayed
 * autosave cannot mark or clear another listing's section (SEC-008).
 *
 * @param {Object} [unsavedSections]
 * @param {string} listingScope
 * @returns {Object} The scoped entry as stored, or one shared frozen empty object
 */
export const unsavedSectionsForListingScope = (unsavedSections, listingScope) => {
  if (typeof listingScope !== "string" || !listingScope) {
    return EMPTY_UNSAVED_SECTIONS;
  }
  const scoped = unsavedSections?.[listingScope];
  if (!scoped || typeof scoped !== "object" || Array.isArray(scoped)) {
    return EMPTY_UNSAVED_SECTIONS;
  }
  return scoped;
};

/**
 * Combined banner/guard status. Failed wins over pending so a durable
 * "not saved" signal is not hidden behind an in-flight retry.
 */
export const listingUnsavedStatus = {
  idle: "idle",
  pending: "pending",
  failed: "failed",
  unsaved: "unsaved"
};

/** Listing id segment from /my-events|jobs|organizations/:id routes (ignores tab segments). */
export const resolveListingIdFromDetailPath = pathname => {
  const segments = String(pathname || "")
    .split("/")
    .filter(Boolean);
  const markerIndex = segments.findIndex(segment => ["my-organizations", "my-events", "my-jobs"].includes(segment));

  if (markerIndex === -1) {
    return null;
  }

  const idSegment = segments[markerIndex + 1];

  if (!idSegment || listingSectionPaths.includes(idSegment)) {
    return null;
  }

  return idSegment;
};

/**
 * API v2 resource segment for listing detail routes.
 * Returns null for legacy individual listings at /listings/:id (json-api).
 *
 * @param {string} pathname
 * @returns {"profiles"|"jobs"|"events"|"organizations"|null}
 */
export const resolveListingApiName = pathname => {
  if (!pathname) {
    return null;
  }
  if (pathname.includes("/profile")) {
    return "profiles";
  }
  if (pathname.includes("/my-organizations")) {
    return "organizations";
  }
  if (pathname.includes("/my-events")) {
    return "events";
  }
  if (pathname.includes("/my-jobs")) {
    return "jobs";
  }
  if (pathname.includes("/listings")) {
    return null;
  }
  const match = pathname.match(/jobs|events|organizations|profile/);
  if (!match) {
    return null;
  }
  return match[0] === "profile" ? "profiles" : match[0];
};

/**
 * Dashboard URLs always use the root (approved parent) listing id.
 * List rows may represent an editor child (draft/pending/synced); parent_id is the canonical id.
 */
export const resolveDashboardListingId = (listingId, parentId) => {
  if (parentId != null && Number(parentId) > 0) {
    return String(parentId);
  }
  return listingId != null ? String(listingId) : listingId;
};

/** Replace the listing id segment in a listing detail pathname. */
export const replaceListingIdInPath = (pathname, listingId) => {
  const segments = pathname.split("/").filter(Boolean);
  const markerIndex = segments.findIndex(segment => LISTING_DETAIL_ENTITY_SEGMENTS.includes(segment));
  if (markerIndex === -1 || listingId == null) {
    return pathname;
  }
  segments[markerIndex + 1] = String(listingId);
  return `/${segments.join("/")}`;
};

/**
 * Parent id the editor URL should be rewritten to, or null to leave the URL alone.
 * A version opened by its own id (draft/pending/synced child) lands on its parent id, but only once the
 * loaded listing is that version: the editor is reused across the /my-* routes, so after Back the payload
 * can still belong to the editor the user just left (GROWTH-7244).
 */
export const resolveParentRedirectId = ({ routeListingId, loadedListingId, parentId }) => {
  const isMissing = value => value == null || value === "";
  // Nothing loaded yet, no parent to go to, or the payload belongs to another listing (this also covers a route
  // without an id and a route that already carries the parent id, whose loaded editor child has a different id).
  if (isMissing(loadedListingId) || !(Number(parentId) > 0) || String(routeListingId) !== String(loadedListingId)) {
    return null;
  }
  return String(parentId);
};

/** Referral-lead notification categories. Events and Jobs are never routed leads, so they never get these. */
export const NOTIFICATION_LEAD_CATEGORIES = ["paid-lead", "probono"];

/** Product cap on SMS recipients per listing (Notification Settings v4.0 § SMS Recipients).
 *  Enforced server-side by NS-09; surfaced in the UI so the badge reflects the limit. */
export const MAX_SMS_RECIPIENTS = 5;

/** Default notification categories, in display order. Private Messages applies to every listing kind (GROWTH-6541). */
export const NOTIFICATION_DEFAULT_CATEGORIES = ["paid-lead", "probono", "private-message", "listing-management", "billing-and-payment"];

/**
 * Listing kind as the notification preferences see it. Profiles and Organizations are "default".
 *
 * @param {Object} [flags]
 * @param {boolean} [flags.isEvents=false]
 * @param {boolean} [flags.isJobs=false]
 * @returns {"events"|"jobs"|"default"}
 */
export const getNotificationListingKind = ({ isEvents = false, isJobs = false } = {}) => {
  if (isEvents) {
    return "events";
  }
  return isJobs ? "jobs" : "default";
};

/**
 * Notification categories a listing kind can actually receive. Unknown kinds get the full default set.
 *
 * @param {string} [listingKind]
 * @returns {string[]}
 */
export const getNotificationCategoriesForKind = listingKind =>
  listingKind === "events" || listingKind === "jobs"
    ? NOTIFICATION_DEFAULT_CATEGORIES.filter(category => !NOTIFICATION_LEAD_CATEGORIES.includes(category))
    : NOTIFICATION_DEFAULT_CATEGORIES;
